export default __webpack_public_path__ + "static/media/help-text.a67af544.png";